export const profileData = [
    {
        key: 'old_password',
        title: 'Current password',
        value: '',
        type: 'input',
        readOnly: false,
    },
    {
        key: 'password',
        title: 'New password',
        value: '',
        type: 'input',
        readOnly: false,
    },
]
